import { RouteObject } from 'react-router-dom';

import ProjectSettingPage from '../../pages/project-setting';

import FeatureListInfoPage from '../../pages/feature-list/info';

const projectSettingRouter: RouteObject = {
  path: 'project-setting',
  element: <ProjectSettingPage />,
  children: [
    {
      path: ':projectId/info',
      element: <FeatureListInfoPage />,
    },
  ],
};

export default projectSettingRouter;
